import Context from './context.component'

export default Context
